import React, { Component, Fragment } from 'react'
import Header from '../component/layout/Header'
import Footer from '../component/layout/Footer'
import { Layout } from 'antd';
import { withRouter } from 'react-router';
import UserSession from '../service/UserSession';

class LoginContainer extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if(!UserSession.getToken()) {
            const _country = localStorage.getItem('_country');
            if(_country){
                this.props.history.push('/login');
            } else {
                this.props.history.push('/country');
            }
        }
    }
    render() {
        const { Content } = Layout;
        return (
            <Fragment>
                <Header/>
                <Content className="main-content">
                   {this.props.children}
                </Content>
                <Footer/>   
            </Fragment>
        )
    }
}

export default withRouter(LoginContainer)